// frontend/src/context/BookingContext.jsx
import React, { createContext, useContext, useState } from 'react';

const BookingContext = createContext();

export const useBooking = () => {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error('useBooking must be used within a BookingProvider');
  }
  return context;
};

export const BookingProvider = ({ children }) => {
  const [searchParams, setSearchParams] = useState({
    origin: '',
    destination: '',
    departureDate: '',
    returnDate: '',
    passengers: 1,
    classType: 'economy',
    tripType: 'one-way'
  });
  
  const [searchResults, setSearchResults] = useState([]);
  const [selectedFlight, setSelectedFlight] = useState(null);
  const [bookingData, setBookingData] = useState(null);

  const updateSearchParams = (params) => {
    setSearchParams(prev => ({ ...prev, ...params }));
  };

  const updateSearchResults = (results) => {
    setSearchResults(results);
  };

  const selectFlight = (flight) => {
    setSelectedFlight(flight);
  };

  const updateBookingData = (data) => {
    setBookingData(data);
  };

  const clearBookingData = () => {
    setSelectedFlight(null);
    setBookingData(null);
  };

  const value = {
    searchParams,
    searchResults,
    selectedFlight,
    bookingData,
    updateSearchParams,
    updateSearchResults,
    selectFlight,
    updateBookingData,
    clearBookingData
  };

  return (
    <BookingContext.Provider value={value}>
      {children}
    </BookingContext.Provider>
  );
};

